import { USER_FRAGMENT } from '../fragments/user.fragments';

export const SEARCH_THREAD_MEMBERS = `
    ${USER_FRAGMENT}

    query SearchThreadMembers(
        $threadId: ID!
        $searchQuery: String!
        $options: SearchThreadMembersOptions
    ) {
        searchThreadMembers(
            threadId: $threadId
            searchQuery: $searchQuery
            options: $options
        ) {
            id
            members {
                user {
                    ...UserFragment
                }
            }
        }
    }
`;